import mediumZoom from 'medium-zoom';
mediumZoom('.img-grid__item img');
// mediumZoom('.gallery-slider__slide img');